import { motion } from "framer-motion";
import { Heart, ArrowDown } from "lucide-react";
import { Link } from "react-router-dom";

const HERO_IMG = "https://images.unsplash.com/photo-1694467648694-0c0d5eeeb43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxkb2dzJTIwbG9va2luZyUyMG91dCUyMHdpbmRvd3xlbnwwfHx8fDE3NzU5NzE1MTN8MA&ixlib=rb-4.1.0&q=85";
const USER_IMG = "https://customer-assets.emergentagent.com/job_pet-care-access/artifacts/nuioa16p_IMG_4034.heic";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-end overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <picture>
          <source srcSet={USER_IMG} type="image/heic" />
          <img
            src={HERO_IMG}
            alt="Oreo Henderson and friends"
            className="w-full h-full object-cover"
          />
        </picture>
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pb-16 md:pb-24 pt-32 w-full">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="max-w-2xl"
        >
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="font-body text-xs font-bold tracking-[0.2em] uppercase text-[#C0603A] mb-4"
          >
            In Loving Memory of Oreo Henderson
          </motion.p>

          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-none text-[#2C2C2A] font-medium mb-6">
            333Oreo
            <span className="block text-3xl sm:text-4xl mt-2 text-[#6C6B66] font-normal">
              Foundation
            </span>
          </h1>

          <p className="font-body text-base sm:text-lg leading-relaxed text-[#3A3A38] mb-8 max-w-lg">
            Because every fur baby deserves a fighting chance. We provide food, supplies,
            and veterinary resources to pet parents in need &mdash; so no one has to make
            the heartbreaking choice LaRonda faced with Oreo.
          </p>

          <div className="flex flex-wrap gap-4">
            <Link
              to="/donate"
              data-testid="hero-donate-button"
              className="bg-[#C0603A] text-white hover:bg-[#A64D29] transition-all duration-300 rounded-full px-8 py-4 font-body font-semibold text-lg inline-flex items-center gap-2 hover:shadow-[0_12px_48px_rgba(192,96,58,0.25)]"
            >
              <Heart className="w-5 h-5" />
              Donate Now
            </Link>
            <Link
              to="/pet-pantry"
              data-testid="hero-pantry-button"
              className="bg-transparent text-[#2C2C2A] border border-[#2C2C2A]/20 hover:border-[#2C2C2A] hover:bg-[#2C2C2A]/5 transition-all duration-300 rounded-full px-8 py-4 font-body font-semibold text-lg"
            >
              Get Help
            </Link>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2"
        >
          <button
            onClick={() => document.getElementById("about")?.scrollIntoView({ behavior: "smooth" })}
            className="text-[#6C6B66] hover:text-[#C0603A] transition-colors animate-bounce"
            data-testid="hero-scroll-down"
          >
            <ArrowDown className="w-6 h-6" />
          </button>
        </motion.div>
      </div>

      {/* Credit */}
      <div className="absolute bottom-4 right-6 z-10">
        <p className="font-body text-[10px] text-[#6C6B66]/60">
          By LaRonda Shree Enterprises LLC
        </p>
      </div>
    </section>
  );
}
